import React from 'react';
import ContentLoader from 'react-content-loader';

const CardLoader = (props: any) => (
  <ContentLoader
    backgroundColor="#f3f3f3"
    foregroundColor="var(--interactive-secondary)"
    height={200}
    speed={2}
    viewBox="0 0 348 200"
    width={348}
    {...props}>
    <rect height="200" rx="16" ry="16" width="348" x="0" y="0" />
  </ContentLoader>
);

export default CardLoader;
